module.exports = __webpack_public_path__ + "files/bb363c9a7a990396ae31dfdf4834fd72.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/foods-1.png
// module id = 1609
// module chunks = 60